import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { submitFooterForm } from '../../_actions'
import {
    Container,
    Row,
    devices,
    colors,
    Button,
    Input,
    Textarea,
    Form,
} from '../Common'


export const Footer = () => {
    const { register, handleSubmit, errors } = useForm()
    // const { footerMessage, footerError } = useSelector(state => state.form, shallowEqual)
    const dispatch = useDispatch()
    const onSubmit = data => dispatch(submitFooterForm(data))

    const formOptions = { required: 'This field is required' }

    return (
        <FooterWrap>
            <FooterContainer>
                <FooterRow>
                    <FooterHeading>Contact Us</FooterHeading>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Input color={colors.inputRed} aria-label="name" name="name" type="text" placeholder="Name" ref={register(formOptions)} />
                        <Input color={colors.inputRed} aria-label="email" name="email" type="email" placeholder="Email" ref={register(formOptions)} />
                        <Input color={colors.inputRed} aria-label="subject" name="subject" type="text" placeholder="Subject" ref={register(formOptions)} />
                        <Textarea aria-label="message" name="message" placeholder="Message" ref={register(formOptions)} />
                        <Button type='submit' onClick={handleSubmit(onSubmit)}>SUBMIT</Button>
                    </Form>
                </FooterRow>
                <FooterRow>
                    <FooterHeading>Info</FooterHeading>
                    <Address>
                        626 West Cavalcade<br />
                        Houston, TX 77009<br />
                        Phone: <a href="tel:7138613331">713.861.3331</a><br />
                        <br />
                        Visit our warehouse<br />
                        — By appointment only
                    </Address>
                    <Icons>
                        <Facebook aria-label='Facebook' href='https://www.faceboook.com/' target='_blank' rel='noopener noreferrer' />
                        <Linkedin aria-label='Linkedin' href='https://www.linkedin.com/' target='_blank' rel='noopener noreferrer' />
                    </Icons>
                </FooterRow>
                <FooterRow>
                    <EventFormLink as={Link} to={'/event-form/'}>Event form</EventFormLink>
                </FooterRow>
            </FooterContainer>
        </FooterWrap>
    )
}

const FooterWrap = styled.footer`
    padding-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    background: ${colors.red};
    color: ${colors.white};
`

const Address = styled.div`
    a {
        text-decoration: none;
        color: ${colors.white};
    }
`

const FooterContainer = styled(Container)`
    max-width: 1400px;
    display: flex;
    justify-content: space-between;
`

const FooterHeading = styled.div`
    text-transform: uppercase;
    margin-bottom: 5px;
    font-family: pragmatica-extended, sans-serif;
    font-weight: 900;
    font-style: normal;
`

const EventFormLink = styled(FooterHeading)`
    position: relative;
    text-decoration: none;
    color: ${colors.white};
    &::after {
        content: '';
        background: url('/static/images/sprite.svg') no-repeat -104px -173px;
        display: inline-block;
        cursor: pointer;
	    width: 13px;
	    height: 11px;
        position: absolute;
        right: -50px;
        top: 18%;
    }
`

const FooterRow = styled(Row)`
    /* @media ${devices.small} { */
        flex-direction: column;
        justify-content: flex-start;
        padding: 0 20px;
    /* } */
`

const Icons = styled.div`
    margin-top: 20px;
`

const SocialIcon = styled.a`
    background-image: url('/static/images/sprite.svg');
    background-repeat: no-repeat;
    background-position-y: -125px;
    margin-right: 10px;
    display: inline-block;
`

const Facebook = styled(SocialIcon)`
    background-position-x: -100px;
    width: 23px;
	height: 22px;
`

const Linkedin = styled(SocialIcon)`
    background-position-x: -127px;
    width: 22px;
	height: 22px;
`

// const FooterInfoWrap = styled.div`
//     width: calc(100% - 330px);
//     max-width: 540px;
//     padding-right: 60px;

//     @media ${devices.small} {
//         width: 100%;
//         max-width: 100%;
//         padding-right: 0;
//     }
// `

// const FooterMenu = styled.div`
//     width: 400px;
//     @media ${devices.small} {
//         width: 100%;
//         border-top: 1px solid ${colors.white};
//         padding-top: 20px;
//         margin-top: 20px;
//     }
// `

